module.exports = __webpack_public_path__ + "images/emoji/two_men_holding_hands.9fd7f0525bb406675089.png";